import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Button, message, Tag, Popconfirm } from 'antd'
import { deleteBasketSet, getBasketNumberSuggest, mergeBasketSet } from '../../../services/api/mergerSetApi'
import convertDateOverTime from '../../merger-v2/helpers/convertDateOverTime'

class MergerSetDetail extends Component {
    state = {
        loading: false,
        error: '',
        basketNumber: null,
        selectedItem: ''
    }

    async componentDidMount() {
        await this.handleBasketNumber()
    }

    async componentDidUpdate(prevProps) {
        // Chỉ chạy lại khi props.result thay đổi
        if (this.props.result !== prevProps.result) {
            await this.handleBasketNumber()
        }
    }

    handleBasketNumber = async () => {
        const { result } = this.props
        const { basket } = result
        // if (result?.basketNumber) {
        // Nếu props.result có basketNumber → set state
        this.setState({ basketNumber: basket.number })
        // } else {
        //     // Nếu chưa có → gọi API
        //     try {
        //         const { data } = await getBasketNumberSuggest()
        //         this.setState({ basketNumber: data?.basketNumber })
        //     } catch (err) {
        //         console.error('Lỗi khi gọi API getBasketNumberSuggest:', err)
        //     }
        // }
    }

    handleSelect = (item) => {
        this.setState({ selectedItem: item })
    }

    addItemToBasket = async () => {
        const { barcode } = this.props
        const { basketNumber, selectedItem } = this.state
        const vBarcode = barcode.replace(/#/gi, '')

        this.setState({
            loading: true,
            error: ''
        })

        try {
            const payload = {
                basket_number: basketNumber,
                set_item: selectedItem
            }
            const { data: response } = await mergeBasketSet(vBarcode, payload)

            const { success, message: msg, data } = response
            const { basket_item = {} } = data || {}

            if (!success) {
                message.error(msg || 'Thêm giỏ set thất bại')
                return this.setState({
                    loading: false
                })
            }

            message.success('Thêm giỏ set thành công!')
            if (basket_item.status === 'completed') {
                this.props.onReset()
            } else {
                this.props.onClose()
                this.props.onFocusInput()
            }
        } catch (e) {
            message.error(e.message)
        } finally {
            this.setState({ loading: false })
        }
    }

    deleteBasket = async () => {
        const { barcode } = this.props
        const { basketNumber } = this.state
        const vBarcode = barcode.replace(/#/gi, '')

        this.setState({
            loading: true,
            error: ''
        })

        try {
            const payload = {
                basket_number: basketNumber
            }
            const { data: response } = await deleteBasketSet(vBarcode, payload)

            const { success, message: msg } = response

            if (!success) {
                message.error(msg || 'Xóa giỏ set thất bại')
                return this.setState({
                    loading: false
                })
            }

            message.success('Xóa giỏ set thành công!')
            this.props.onClose()
            this.props.onFocusInput()
        } catch (e) {
            message.error(e.message)
        } finally {
            this.setState({ loading: false })
        }
    }

    render() {
        const { basketNumber, selectedItem } = this.state
        const { result } = this.props
        const { order, basket_item } = result

        const isBarcodeItemHaveBasket = basket_item && basket_item !== null
        const itemOptions = isBarcodeItemHaveBasket ? basket_item.set : order.meta.set_items
        const itemSetAlready = isBarcodeItemHaveBasket ? basket_item.set.filter(item => item.status === 'added').map(item => item.name) : []

        const isGiftTag = !!order.tags && Array.isArray(order.tags) && order.tags.includes('gift')
        const isSampleTag = !!order.tags && Array.isArray(order.tags) && order.tags.includes('sample')
        const isFbaTag = !!order.tags && Array.isArray(order.tags) && (order.tags.includes('FBA') || order.tags.includes('fba'))
        const isFastShipTag = !!order.tags && Array.isArray(order.tags) && order.tags.includes('fastship')
        const isUIDSAMPLETag = !!order.tags && Array.isArray(order.tags) && order.tags.includes('UIDSAMPLE')
        const isFastProductionTag = !!order.tags && Array.isArray(order.tags) && order.tags.includes('fastproduction')
        const isTikTokTag = !!order.tags && Array.isArray(order.tags) && order.tags.includes('tiktok')
        const isCutOff = !!order.tags && Array.isArray(order.tags) && order.tags.includes('cutoff')
        const isCutOffNoel = !!order.tags && Array.isArray(order.tags) && order.tags.includes('cutoff_noel')
        const isCutOffNewYear = !!order.tags && Array.isArray(order.tags) && order.tags.includes('cutoff_new_year')
        const isSLLTag = !!order.tags && Array.isArray(order.tags) && order.tags.includes('SLL')
        const is24hTag = !!order.tags && Array.isArray(order.tags) && order.tags.includes('24h')

        const overtimeText = !!order.overtime ? convertDateOverTime(order.overtime) : '-'

        return (
            <div className={classNames("MergerSetDetail")}>
                <div className="MergerSetDetailContainer">
                    <div className='MergerSetBasketDetail'>
                        <div className='MergerSetBasketDetailBox'>
                            <div className='d-flex justify-content-between align-items-center mb-2'>
                                <div className='skuInfo'>
                                    <label>SKU:</label><strong>{order.type}</strong>
                                </div>
                                {
                                    isBarcodeItemHaveBasket &&
                                    <div className={`basketStatus ${basket_item.status}`}>
                                        {
                                            basket_item.status === 'partial' ? <span>Chưa đủ SET</span> : basket_item.status === 'completed' ? <span>Đủ SET</span> : ''
                                        }
                                    </div>
                                }

                            </div>
                            <div className='ListItemSetContainer'>
                                <label className='mb-2'>Chọn item trong SET để thêm vào giỏ</label>

                                <div className='ListItemSet d-flex align-items-center'>
                                    {
                                        itemOptions && itemOptions.length > 0 &&
                                        itemOptions.map((item, index) => (
                                            <div
                                                key={index}
                                                className={`item-box ${selectedItem === item.name ? 'active' : ''}`}
                                                onClick={() => this.handleSelect(item.name)}
                                                style={{
                                                    cursor: 'pointer',
                                                    border: selectedItem === item.name ? '1px solid #007bff' : '1px solid #ccc',
                                                    borderRadius: 4,
                                                    padding: '7px 12px',
                                                    margin: '0 10px 10px 0',
                                                }}
                                            >
                                                <strong>{item.name}</strong>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            {
                                itemSetAlready.length > 0 &&
                                <div className='setItemAlready'>
                                    <label>Đã có:</label> {itemSetAlready.join(', ')}
                                </div>
                            }

                        </div>

                        <div className='MergerSetBasketDetailTags mt-3'>
                            {
                                isGiftTag &&
                                <div>
                                    <Tag color="#6c757d">Hàng tặng</Tag>
                                </div>
                            }

                            {
                                isSampleTag &&
                                <div>
                                    <Tag color="#6c757d">Hàng mẫu</Tag>
                                </div>
                            }

                            {
                                isFbaTag &&
                                <div>
                                    <Tag color="#6c757d">FBA</Tag>
                                </div>
                            }

                            {
                                isFastShipTag &&
                                <div>
                                    <Tag color="#6c757d">Ship nhanh</Tag>
                                </div>
                            }

                            {
                                isUIDSAMPLETag &&
                                <div>
                                    <Tag color="#6c757d">UIDSAMPLE</Tag>
                                </div>
                            }

                            {
                                isFastProductionTag &&
                                <div>
                                    <Tag color="#FFA500">Sản xuất nhanh</Tag>
                                </div>
                            }

                            {
                                isTikTokTag &&
                                <div>
                                    <Tag color="#dc3644">TIKTOK</Tag>
                                </div>
                            }

                            {
                                is24hTag &&
                                <div>
                                    <Tag color="#dc3644">24h</Tag>
                                </div>
                            }

                            {
                                isCutOff &&
                                <div>
                                    <Tag color="#FF6600">cutoff</Tag>
                                </div>
                            }

                            {
                                isCutOffNoel &&
                                <div>
                                    <Tag color="#FF6600">cutoff_noel</Tag>
                                </div>
                            }

                            {
                                isCutOffNewYear &&
                                <div>
                                    <Tag color="#FF6600">cutoff_new_year</Tag>
                                </div>
                            }

                            {
                                isSLLTag &&
                                <div>
                                    <Tag color="#fdb813">SLL</Tag>
                                </div>
                            }

                            {
                                order.overtime && order.overtime > 0 &&
                                <div>
                                    <Tag color="#dc3644">Quá hạn {overtimeText}</Tag>
                                </div>
                            }
                        </div>
                    </div>
                    <div className='MergerSetBasketNumber'>
                        <div className='MergerSetBasketNumberBox'>
                            <div className='d-flex flex-column align-items-center'>
                                <label>Số giỏ</label>
                                <span className='basketNumber'>{basketNumber}</span>
                            </div>
                        </div>

                        <div className='MergerSetActions mt-3 d-flex flex-column align-items-center'>
                            {
                                selectedItem !== '' &&
                                <>
                                    {
                                        !isBarcodeItemHaveBasket &&
                                        <Button type="primary" onClick={this.addItemToBasket}>Xác nhận vào giỏ</Button>
                                    }

                                    {
                                        isBarcodeItemHaveBasket && basket_item.status === 'partial' &&
                                        <Button type="primary" onClick={this.addItemToBasket}>Thêm tiếp vào giỏ</Button>
                                    }
                                </>
                            }

                            {
                                isBarcodeItemHaveBasket && basket_item.status === 'completed' &&
                                <Popconfirm
                                    title="Có chắc chắn muốn xóa giỏ?"
                                    onConfirm={this.deleteBasket}
                                    okText="Xóa"
                                    cancelText="Hủy"
                                >
                                    <Button type="danger" variant="solid">Xóa giỏ</Button>
                                </Popconfirm>

                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

MergerSetDetail.propTypes = {
    disabledCheckExists: PropTypes.bool,
    result: PropTypes.object.isRequired,
}

export default MergerSetDetail
